/**
 * Indexer API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
package indexer.codegen

import kotlinx.serialization.Serializable
import kotlin.js.JsExport

/**
 *
 * Values: LIMIT,MARKET,STOP_LIMIT,STOP_MARKET,TRAILING_STOP,TAKE_PROFIT,TAKE_PROFIT_MARKET,TWAP,TWAPSUBORDER
 */
@JsExport
@Serializable
enum class IndexerOrderType(val value: kotlin.String) {
    LIMIT("LIMIT"), // :/
    MARKET("MARKET"), // :/
    STOP_LIMIT("STOP_LIMIT"), // :/
    STOP_MARKET("STOP_MARKET"), // :/
    TRAILING_STOP("TRAILING_STOP"), // :/
    TAKE_PROFIT("TAKE_PROFIT"), // :/
    TAKE_PROFITMARKET("TAKE_PROFIT_MARKET"), // :/
    TWAP("TWAP"), // :/
    TWAPSUBORDER("TWAP_SUBORDER"); // :/
}
